// https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html

const makeCancelable = (promise) => {
    let hasCanceled_ = false;

    const wrappedPromise = new Promise((resolve, reject) => {
        promise.then(
            val => (hasCanceled_
                ? reject({isCanceled: true})
                : resolve(val)),
            error => (hasCanceled_
                ? reject({isCanceled: true})
                : reject(error))
        );
    });

    return {
        promise: wrappedPromise,
        cancel() {
            hasCanceled_ = true;
        },
    };
};


// https://github.com/hjylewis/trashable/blob/master/src/index.js
const makeTrashable = (promise) => {
    let trash = () => {
        // Do Nothing
    };

    const wrappedPromise = new Promise((resolve, reject) => {
        trash = () => {
            resolve = null;
            reject = null;
        };

        promise.then(
            (val) => {
                if (resolve) {
                    resolve(val);
                }
            },
            (error) => {
                if (reject) {
                    reject(error);
                }
            },
        );
    });

    wrappedPromise.trash = trash;
    return wrappedPromise;
};


// const p1 = new Promise((resolve, reject) => {
//
//     resolve(1);
//     setTimeout(() => reject({isCanceled: true}), 200);
// });
// p1.then(rst => console.log(`rst : ${rst}`), err => console.warn(`err : ${err}`)); // rst : 1
//
// // wait 1s
//
// p1.then(rst => console.log(`rst : ${rst}`), err => console.warn(`err : ${err}`)); // rst : 1
//
//
// //------------------------------------------------
//
// const p2 = new Promise((resolve, reject) => {
//     reject({isCanceled: true});
//     setTimeout(() => resolve(1), 200);
// });
// p2.then(rst => console.log(`rst : ${rst}`), err => {    // err  {isCanceled: true}
//     console.log("err");
//     console.warn(err);
// });
//
// // wait 1s
//
// p2.then(rst => console.log(`rst : ${rst}`), err => {    // err  {isCanceled: true}
//     console.log("err");
//     console.warn(err);
// });


export default {
    makeCancelable,
    makeTrashable,
};
